/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxLoaderComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxloader';

/**
 * Loader
 */
@Component({
    selector: 'ngc-loader',
    template: `<jqxLoader #jqxLoader
                [autoOpen] = "autoOpen"
                [html] = "html"
                [isModal] = "isModal"
                [imagePosition] = "imagePosition"
                [rtl] = "rtl"
                [text] = "text"
                [textPosition] = "textPosition"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxLoader>`
})
export class NgcLoaderComponent extends ControlComponent {
    @Input('autoOpen') autoOpen: any;
    @Input('html') html: any;
    @Input('isModal') isModal: any;
    @Input('imagePosition') imagePosition: any;
    @Input('rtl') rtl: any;
    @Input('text') text: any;
    @Input('textPosition') textPosition: any;
    @Input('theme') theme: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    @ViewChild('jqxLoader') jqxLoader: jqxLoaderComponent;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    open($e) {
        this.jqxLoader.open();
    }

    close($e) {
        this.jqxLoader.close();
    }
}

/**
 * Loader Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcLoaderComponent],
    declarations: [NgcLoaderComponent, jqxLoaderComponent]
})
export class NgcLoaderModule {
}